<template>
  <div :class="{'pc-bg':isMobile == 'pc'}">
    <div class="foundation-project-details" v-if="isMobile == 'pc'">
      <el-row :gutter="20">
        <el-col :span="screenWidth<=540?24:10">
          <img :src="object.imgUrl" alt="" style="width: 100%;">
        </el-col>
        <el-col :span="screenWidth<=540?24:14" :style="{'margin-top':screenWidth<=540?'2rem':0}">
          <div>
            <sapn style="font-size: 1.3rem;font-weight: 500;" v-if="screenWidth>540">{{ object.title }}</sapn>
            <div>
              <div style="font-size: 1rem;position: relative;line-height: 2rem;">
			  <div v-html="object.content"></div>
			  </div>
            </div>
            <el-divider></el-divider>
            <div class="files-box">
              <div v-for="item in object.files" :key="item.id" class="files-item">
                <div style="font-size: 0.9rem;">{{ item.fileName }}</div>
                <div class="btn-more" style="font-size: 0.7rem;width: 6rem;height: 1.5rem;line-height: 1.5rem;" @click="toDownload(item.url,item.name)">
                  {{$t('ViewDetails')}} <i class="el-icon-download"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>



    <!-- 移动端 -->
    <div class="foundation-project-details-mobile" v-if="isMobile == 'mobile'">
      <el-row :gutter="20">
        <el-col :span="screenWidth<=540?24:10">
          <img :src="object.imgUrl" alt="" style="width: 100%;">
        </el-col>
        <el-col :span="screenWidth<=540?24:14" :style="{'margin-top':screenWidth<=540?'2rem':0}">
          <div>
            <sapn style="font-size: 1.3rem;font-weight: 500;" v-if="screenWidth>540">{{ object.title }}</sapn>
            <div>
              <!-- <span style="font-size: 3rem;line-height: 3rem;">·</span> -->
              <div style="font-size: 1rem;position: relative;line-height: 2rem;">
			  <div v-html="object.content"></div>
			  
			  </div>
            </div>
            <el-divider></el-divider>
            <div class="files-box">
              <div v-for="item in object.files" :key="item.id" class="files-item">
                <div style="font-size: 0.9rem;">{{ item.fileName }}</div>
                <div class="btn-more" style="font-size: 0.7rem;width: 6rem;height: 1.5rem;line-height: 1.5rem;" @click="toDownload(item.url,item.name)">
                  {{$t('ViewDetails')}} <i class="el-icon-download"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  
</template>

<script>
import { mapState } from 'vuex'
import { getRemembering } from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      object: {},
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    toDownload(url, name) {
      const link = document.createElement('a');
      link.href = url;
      link.download = name + '.ext';
      link.click();
    },

    getData() {
      const formData = new FormData();
      formData.append("moduleId", 7);
      getRemembering(formData).then(res => {
        if (res.data && res.data != null) {
          this.object = res.data;
        }
      })
    }
  },


};
</script>

<style lang="less" scoped>
.pc-bg{
  background: #fff;
}
.foundation-project-details {
  // background: linear-gradient(to bottom, #f9f9fa, white);
  background: #fff;
  width: 80%;
  margin: 3rem auto;
  padding: 3rem;
  margin-top: 0;
  box-sizing: border-box;
  .foundation-project-details-img-title {
    margin: 3rem 0;
    text-align: center;
  }
  .foundation-project-details-img {
    width: 100%;
    margin-top: 3rem;
  }
}

// 移动端
.foundation-project-details-mobile {
  // background: linear-gradient(to bottom, #f9f9fa, white);
  background: #fff;
  width: 100%!important;
  margin: 3rem auto 0;
  padding: 3rem;
  margin-top: 0;
  box-sizing: border-box;
  .foundation-project-details-img-title {
    margin: 3rem 0;
    text-align: center;
  }
  .foundation-project-details-img {
    width: 100%;
    margin-top: 3rem;
  }
}

.organization-img {
  width: 100%;
  margin-top: 2rem;
}
.files-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  word-wrap: break-word;
  word-break: break-all;
}
.files-box {
  margin-top: 1rem;
  width: 60%;
  float: right;
}
</style>